import { isUserLoggedIn } from '../../utilities/AuthService';
import { LOGIN } from '../../navigator/links';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

type AuthenticationProtectedProps = {
  children: JSX.Element | React.ReactNode;
};

function AuthenticationProtected({ children }: AuthenticationProtectedProps): JSX.Element | null {
  const isLoggedIn = isUserLoggedIn();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(`${LOGIN}${location.search}`, { replace: true });
    }
  });

  if (isLoggedIn) {
    return <>{children}</>;
  }
  return <></>;
}

export default AuthenticationProtected;
